import { jsx as s, jsxs as n, Fragment as B } from "react/jsx-runtime";
import d, { createElement as M } from "react";
import { PREFIX as e } from "../../constants/site.js";
import S from "../../util/bootstrapUtil.js";
import { MBIcon as v } from "../app/mbIcon.js";
import { MBTooltip as y } from "../app/mbTooltip.js";
import "../../constants/bootstrapContants.js";
import "react-bootstrap";
const R = ["input", "select", "textarea", "fieldset", "datalist", "output", "option", "optgroup"], T = S.getFormTypes(), Y = ({
  id: r,
  label: b,
  subLabel: c,
  labelTooltip: m,
  isBlock: f,
  htmlFor: u,
  isLabelColonOmitted: $,
  children: a,
  isRequiredField: N = !1,
  ...t
}) => {
  const g = t.className ?? "", E = `${e}${f ? "" : "-inline"}-label-group`;
  t.className = `${E} ${g}`, N && (t.className += `${e}-required-field`);
  const h = d.isValidElement(a);
  let l;
  h && (l = d.Children.toArray(a)[0].type);
  const o = !!l && (R.includes(l) || T.includes(l == null ? void 0 : l.displayName) || !!l.moment), C = o ? "label" : "span", i = [];
  $ && i.push(`${e}-check-box-label`), o || i.push(`${e}-label-group-label`);
  const p = { className: i.join(" ") };
  o && (p.htmlFor = u);
  const F = /* @__PURE__ */ n(B, { children: [
    b,
    !!c && /* @__PURE__ */ n("small", { children: [
      " ",
      c,
      " "
    ] }),
    !!m && /* @__PURE__ */ s(y, { id: `tooltip-${r}`, message: m, className: `${e}-label-tooltip`, children: /* @__PURE__ */ s("div", { className: `${e}-tooltip-icon-container`, children: /* @__PURE__ */ s(v, { className: `${e}-fs-sm ${e}-mb-2`, icon: "help" }) }) })
  ] }), x = M(C, p, F);
  return /* @__PURE__ */ s("div", { className: `${e}-label-group-container`, children: /* @__PURE__ */ n("div", { ...t, id: `labelGroup-${r}`, children: [
    x,
    /* @__PURE__ */ s("div", { className: `${e}-label-group-content`, children: a })
  ] }) });
};
export {
  Y as MBLabelGroup
};
